import React from 'react';
import './Headshotheader.css';

const Headshotheader = ({ content = {} }) => {
  return (
    <section
      className="Headshotheader"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${content.heroImage || '/Headshot-header-image.jpg'})` }}
    >
      <div className="overlay"></div>
      <div className="content">
        <h1>{content.title || 'Headshots Packages'}</h1>
        <div className="underline"></div>
      </div>
    </section>
  );
};

export default Headshotheader;
